module.exports = __webpack_public_path__ + "img/left-arm.8c980937.png";